// src/store/sagas.js

import { takeLatest, call, put } from "redux-saga/effects";
import eAxios from "../../eAxios";
import { staticData } from "./data";
import {
  GET_CLASSROOMS,
  GET_MEDIA,
  GET_OVERALL_DATA,
  GET_TRANSCRIPTION,
} from "./actionTypes";
import {
  gotClassrooms,
  fetchClassroomsError,
  gotMedia,
  fetchMediaError,
  gottranscripton,
  fetchTranscriptionError,
  gotoveralldata,
  fetchoveralldataError,
} from "./actions";

const doGetClassroomList = () => eAxios.get(`/get_classrooms/`);
// const doGetMediaList = () => eAxios.get("/get_files/");
const doGetMediaList = (classroom_id) =>
  eAxios.post("/get_files/", { classroom_id });

const doGetTranscription = (file_id, file_type) =>
  eAxios.post("/get_transcription/", { file_id, file_type });

const doGetOverAllData = () => eAxios.get(`/get_overall_data/`);

function* getClassroomList() {
  try {
    const response = yield call(doGetClassroomList);
    yield put(gotClassrooms(response.data.data));
  } catch (error) {
    yield put(fetchClassroomsError(error.message));
  }
}

function* getMediaList(action) {
  try {
    const classroom_id = action.payload;
    const response = yield call(doGetMediaList, classroom_id);
    // Assuming response.data contains both audios and videos

    yield put(gotMedia(response.data.data));
  } catch (error) {
    yield put(fetchMediaError(error.message));
  }
}
function* getTranscription(action) {
  try {
    const { file_id, file_type } = action.payload;
    const response = yield call(doGetTranscription, file_id, file_type);

    yield put(gottranscripton(response.data.data[0]));
  } catch (error) {
    yield put(fetchTranscriptionError(error.message));
  }
}

function* getOverallData() {
  try {
    
    // const response = yield call(doGetOverAllData);
  
    yield put(gotoveralldata(staticData.data));
  } catch (error) {
    yield put(fetchoveralldataError(error.message));
  }
}

export default function* rootSaga() {
  yield takeLatest(GET_CLASSROOMS, getClassroomList);
  yield takeLatest(GET_MEDIA, getMediaList);
  yield takeLatest(GET_TRANSCRIPTION, getTranscription);
  yield takeLatest(GET_OVERALL_DATA, getOverallData);
}
